import { render, staticRenderFns } from "./UserChange.vue?vue&type=template&id=32a40844&"
import script from "./UserChange.vue?vue&type=script&lang=js&"
export * from "./UserChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports